<div class="card-wrapper">
  <div
    class="grv-card grv-padding__top--normal grv-padding__bottom--normal grv-text--medium-1 grv-color--digital-gray-100"
  >
    <div class="request-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
